import Vue from 'vue';
import firebase from '@/plugins/firebase';

interface Calendar {
	href: string,
	text: string,
	id?: string,
	category?: string,
}

export default Vue.extend({
  data() {
    return {
      fetching: true,
      username: '',
      password: '',
      authenticating: false,
      remember: false,
      calendars: [],
      dialog: false,
      linkFieldMessage: '',
      search: '',
    };
  },
  // computed: {
  // 	items(){
  // 		if (this.search){
  // 			const words = this.search.split(' ').map(word => word.trim());
  // 			return (this.calendars as Calendar[]).filter(calendar => {
  // 				if (calendar.category){
  // 					return true;
  // 				}
  // 				return words.every(word => calendar.text.includes(word));
  // 			});
  // 		} else {
  // 			return this.calendars;
  // 		}
  // 	}
  // },
  methods: {
    matchesSearch(calendar: Calendar) {
      if (this.search) {
        const words = this.search.toLowerCase().split(' ').map(word => word.trim());
        if (calendar.category) {
          return true;
        }
        return words.every(word => calendar.text.toLowerCase().includes(word));
      }
      return true;
    },
    authenticate() {
      const words = this.search.split(' ').map(word => word.trim());
      this.authenticating = true;
      this.$store.dispatch('users/storeWriteOnly', {
        user_uid: this.$auth.state.uid,
        docName: 'farmers-wife',
        data: {
          username: this.username,
          password: btoa(this.password),
        },
      }).then(() => {
        this.$store.dispatch('users/store', {
          uid: this.$auth.state.uid,
          farmersWifeUser: this.username,
        });
        this.fetchCalendars();
      }).catch((error) => {
        this.$store.commit('alerts/insert', { type: 'error', message: error });
        // alert(error);
      }).finally(() => {
        this.authenticating = false;
      });
    },
    fetchCalendars() {
      this.fetching = true;
      firebase.functions().httpsCallable('webcal').call({
        // username: this.username,
        // password: this.password,
      }).then((result: any) => {
        this.calendars = result.data;
        firebase.firestore().collection('calendars')
				  .where('user', '==', this.$auth.state.uid).get()
          .then((calendars) => {
				  	calendars.forEach((calendarDoc) => {
				  		const calendar = calendarDoc.data();
				  		if (!calendar) {
				  			return;
				  		}
				  		if (calendar.href) {
				  			const entry: any = this.calendars.find((item: any) => item.href === calendar.href);
				  			if (entry) {
				  				this.$set(entry, 'id', calendarDoc.id);
				  				// entry.relay = this.relayUrl(calendarDoc.id);
				  			}
				  		}
				  	});
          });
      })
        .catch((error: any) => {
          console.error(error);
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    createCalendarLink(calendar: any, event: Event) {
      firebase.firestore().collection('calendars').add({
        ...calendar,
        user: this.$auth.state.uid,
      }).then((calendarDoc) => {
  				this.$set(calendar, 'id', calendarDoc.id);
  				this.dialog = calendar;
      })
        .catch((error) => {
          this.$store.commit('alerts/insert', { type: 'error', message: error });
        });
    },
    removeCalendar(calendar: any) {
      firebase.firestore().collection('calendars').doc(calendar.id).delete()
        .then(() => {
          calendar.id = undefined;
        })
        .catch((error) => {
          this.$store.commit('alerts/insert', { type: 'error', message: error });
        });
    },
    relayUrl(id: string) {
      if (require('@/config.ts').default.projectId === 'hocus-focus-production') {
        return `https://cloud.hocusfocus.no/webcal/${id}.ics`;
      }
      return `https://us-central1-hocus-focus-18a9f.cloudfunctions.net/webcal/${id}.ics`;
    },
    copy() {
      const input = document.getElementById('linkfield') as HTMLInputElement;
      if (!input) {
        return;
      }
		    input.select();
		    input.setSelectionRange(0, 99999); /* For mobile devices */
		    document.execCommand('copy');
		    this.linkFieldMessage = 'Copied to clipboard';
    },
  },
  mounted() {
    this.fetchCalendars();
  },
  watch: {
    dialog(to, from) {
      this.linkFieldMessage = '';
    },
  },
});
